var map = {
	"./icon-excel.png": "fc37",
	"./icon-image.png": "7039",
	"./icon-link.png": "ab21",
	"./icon-music.png": "7b61",
	"./icon-other.png": "974f",
	"./icon-pdf.png": "3df4",
	"./icon-ppt.png": "0538",
	"./icon-txt.png": "f8e9",
	"./icon-video.png": "4bdd",
	"./icon-word.png": "7665",
	"./icon-zip.png": "2a96"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9797";